<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_v2 board_search_wrap">
                            <div class="bo_sch_content">
                                <div class="sch_box">
                                    <div class="bo_sch_content">
                                        <span class="bo_sch_tit">기간</span>
                                        <DateRange :date="state.date" @changeDate="selectDate"></DateRange>
                                    </div>
                                    <div class="sch_btns">
                                        <button type="button" class="sch_btn" @click="getData()">검색하기</button>
                                        <button type="button" class="sch_re_btn" @click="resetFilter()">
                                            <img src="@/assets/board/re_btn.png" alt="" />
                                            초기화
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 통계 탭 메뉴 -->
                        <div class="board_top statis">
                            <div class="board_cate_btns">
                                <button
                                    v-for="item in tabMenu"
                                    :class="{ active: state.tabmenu === item.idx }"
                                    @click="selectTab(item.idx)"
                                >
                                    {{ item.name }}
                                </button>
                            </div>
                        </div>
                        <div class="board_graph_wrap">
                            <Monitoring
                                v-if="state.tabmenu === 1"
                                :loading="state.isLoading"
                                :list="table.monitoring"
                                :chartData="chartData.monitoring"
                            ></Monitoring>
                            <Performance
                                v-else-if="state.tabmenu === 2"
                                :loading="state.isLoading"
                                :chartData="chartData.performance"
                            ></Performance>
                            <Keyword
                                v-else-if="state.tabmenu === 3"
                                :loading="state.isLoading"
                                :list="table.keyword"
                                :currentPage="state.currentPage"
                                :totalLength="state.totalLength"
                                :perPage="state.perPage"
                                @onPaging="selectPage"
                            ></Keyword>
                            <WordCloud
                                v-else-if="state.tabmenu === 4"
                                :loading="state.isLoading"
                                :chartData="chartData.wordcloud"
                            ></WordCloud>
                            <CoOccurrence
                                v-else-if="state.tabmenu === 5"
                                :loading="state.isLoading"
                                :links="chartData.coOccurence"
                            ></CoOccurrence>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" config>
    import {
        Header,
        Menu,
        reactive,
        onMounted,
        globalStore,
        Chart,
        DateRange,
        apiService,
        watch,
        numberFormat,
        LayoutOption,
        Spinner,
        getYearDate,
        dateFormat,
    } from "@/BaseComponent";
    import Monitoring from "./monitoring.vue";
    import Performance from "./performance.vue";
    import Keyword from "./keyword.vue";
    import WordCloud from "./wordCloud.vue";
    import CoOccurrence from "./coOccurrence.vue";

    export default {
        props: [],
        components: {
            Header,
            Menu,
            Chart,
            DateRange,
            Spinner,
            Monitoring,
            Performance,
            Keyword,
            WordCloud,
            CoOccurrence,
        },

        setup() {
            const global = globalStore();
            const state = reactive({
                date: [] as Array<Date>,
                tabmenu: 1 as number,
                showData: 0 as number,

                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 10 as number,

                isLoading: true as boolean,
            });

            const table = reactive({
                monitoring: [] as Array<any>,
                keyword: [] as Array<any>,
            });

            const chartData = reactive({
                monitoring: [] as Array<any>,
                performance: [] as Array<any>,
                wordcloud: [] as Array<any>,
                coOccurence: [] as Array<any>,
            });

            const tabMenu = [
                { idx: 1, name: "모니터링" },
                { idx: 2, name: "검색 실적" },
                { idx: 3, name: "키워드" },
                { idx: 4, name: "워드클라우드" },
                { idx: 5, name: "공출현네트워크" },
            ];

            const snsList = [
                { idx: 1, name: "X (구 트위터)" },
                { idx: 6, name: "블루스카이" },
                { idx: 2, name: "구글" },
                { idx: 3, name: "네이버" },
                { idx: 4, name: "유튜브" },
                { idx: 5, name: "인스타" },
            ];

            const chartLayout = reactive({
                type: "line",
                xAxisKey: "month",

                valueUnit: "개", // 값의 단위
                useLegend: true, // 범례 표시 여부
                useToolbox: true, //다운로드 기능
                useScroll: true, // 스크롤 확대/축소 사용 여부
            } as LayoutOption);

            onMounted(() => {
                global.setSelectMenu(3);
                if (global.searchDate.length === 0) {
                    const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                    const endDate = new Date();
                    state.date = [startDate, endDate];
                } else {
                    state.date = global.searchDate;
                }
                getData();
            });

            watch(
                () => global.searchDate,
                (newDate) => {
                    state.date = newDate;
                },
            );

            const getTableData = async () => {
                table.monitoring = [];
                state.isLoading = true;
                const res: any = await apiService.statistics.monitoring(state.showData, state.date);
                if (res.returnCode === 0) {
                    table.monitoring = res.list1.list;
                }
                state.isLoading = false;
            };

            const getChartData = async () => {
                chartData.monitoring = [];
                for (const sns of snsList) {
                    const res = await apiService.statistics.graph(sns.idx, getYearDate());
                    if (res.returnCode === 0) {
                        chartData.monitoring.push(res.list);
                    }
                }
            };

            const getParformance = async () => {
                state.isLoading = true;
                chartData.performance = [];
                const res = await apiService.statistics.resultGraph(state.date);
                if (res.returnCode === 0) {
                    chartData.performance = res.list ?? [];
                } else {
                    chartData.performance = [];
                }
                state.isLoading = false;
            };

            const getResultKeyword = async () => {
                table.keyword = [];
                state.isLoading = true;
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    startDate: dateFormat(new Date(state.date[0])),
                    endDate: dateFormat(new Date(new Date(state.date[1]))),
                };
                const res: any = await apiService.statistics.getResultKeyword(param);
                if (res.returnCode === 0) {
                    table.keyword = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                }
                state.isLoading = false;
            };

            const getWordcloudData = async () => {
                state.isLoading = true;
                chartData.wordcloud = [];
                const param = {
                    startDate: dateFormat(new Date(state.date[0])),
                    endDate: dateFormat(new Date(new Date(state.date[1]))),
                };
                const res = await apiService.statistics.getWordcloud(param);
                if (res.returnCode === 0) {
                    chartData.wordcloud = res.list ?? [];
                } else {
                    chartData.wordcloud = [];
                }
                state.isLoading = false;
            };

            const getCoOccurence = async () => {
                state.isLoading = true;
                chartData.coOccurence = [];
                const param = {
                    startDate: dateFormat(new Date(state.date[0])),
                    endDate: dateFormat(new Date(new Date(state.date[1]))),
                };
                const res = await apiService.statistics.getCoOccurence(param);
                if (res.returnCode === 0) {
                    chartData.coOccurence = res.list ?? [];
                } else {
                    chartData.coOccurence = [];
                }
                state.isLoading = false;
            };

            const resetFilter = () => {
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                state.date = [startDate, endDate];
                global.setSearchDate(state.date);
                getData();
            };

            const getData = () => {
                if (state.tabmenu === 1) {
                    getTableData();
                    getChartData();
                } else if (state.tabmenu === 2) {
                    getParformance();
                } else if (state.tabmenu === 3) {
                    getResultKeyword();
                } else if (state.tabmenu === 4) {
                    getWordcloudData();
                } else if (state.tabmenu === 5) {
                    getCoOccurence();
                }
            };

            const selectDate = (date: any) => {
                state.date = date;
                global.setSearchDate(date);
            };

            const selectTab = (idx: number) => {
                state.tabmenu = idx;
                state.currentPage = 1;
                getData();
            };

            const selectPage = (page: number) => {
                state.currentPage = page;
                getData();
            };

            return {
                state,
                table,
                chartData,
                tabMenu,
                chartLayout,
                resetFilter,
                getData,
                selectDate,
                numberFormat,
                selectTab,
                selectPage,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }
</style>
